import { LinkBubbleMenu as MuiLinkBubbleMenu } from "mui-tiptap";
import { useRichTextEditorContext } from "mui-tiptap";
import { useEffect, useState } from "react";

/**
 * Custom LinkBubbleMenu that only shows for text links
 * Images have their own link management via MenuButtonImageLink
 */
export function LinkBubbleMenu() {
  const editor = useRichTextEditorContext();
  const [shouldShow, setShouldShow] = useState(true);

  useEffect(() => {
    if (!editor) return;

    const updateVisibility = () => {
      const { state } = editor;
      const { selection } = state;
      const node = state.doc.nodeAt(selection.from);

      // Hide if an image is selected
      setShouldShow(node?.type.name !== "image");
    };

    editor.on("selectionUpdate", updateVisibility);
    updateVisibility();

    return () => {
      editor.off("selectionUpdate", updateVisibility);
    };
  }, [editor]);

  // Don't render at all if an image is selected
  if (!shouldShow) {
    return null;
  }

  return <MuiLinkBubbleMenu />;
}
